var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45809",
    "data-name": "Group 45809",
    transform: "translate(-0.002 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M32.5,65A32.5,32.5,0,0,1,9.52,9.521,32.5,32.5,0,0,1,55.482,55.483,32.291,32.291,0,0,1,32.5,65Zm7.129-44.312a2.986,2.986,0,0,0-2.778,3.15V40.332a2.985,2.985,0,0,0,2.778,3.149A2.982,2.982,0,0,0,42.4,40.332V23.838A2.983,2.983,0,0,0,39.628,20.688Zm-14.7,0a2.986,2.986,0,0,0-2.778,3.15V40.332a2.985,2.985,0,0,0,2.778,3.149,2.984,2.984,0,0,0,2.782-3.149V23.838A2.985,2.985,0,0,0,24.933,20.688Z",
    transform: "translate(0.002 -0.002)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseLg);
export default __webpack_public_path__ + "static/media/pause_lg.f9483fa23d28d5fae3d7628c8321acef.svg";
export { ForwardRef as ReactComponent };